import { useMemo, useState } from 'react';

import type { ProjectStore } from '../domain/store.js';
import { StoreContext, UiContext } from './hooks.js';
import { DesktopNotice } from './DesktopNotice.js';
import { LicenseDialog } from './LicenseDialog.js';
import { Shell } from './Shell.js';

export function App({ store }: { store: ProjectStore }) {
  const [licenseOpen, setLicenseOpen] = useState(false);
  const ui = useMemo(
    () => ({ openLicenseDialog: () => setLicenseOpen(true) }),
    [],
  );
  return (
    <StoreContext.Provider value={store}>
      <UiContext.Provider value={ui}>
        <div className="app-wrap">
          <DesktopNotice />
          <Shell />
        </div>
        {licenseOpen && (
          <LicenseDialog onClose={() => setLicenseOpen(false)} />
        )}
      </UiContext.Provider>
    </StoreContext.Provider>
  );
}
